import Immutable from 'immutable';
import { Dispatch, Reducer } from 'redux';
import { OneAppStore } from '../types/OneAppStore';

const SET_AUTHENTICATED = 'one-ap-root/SET_AUTHENTICATED';

export const setAuthenticated = () => ({ type: SET_AUTHENTICATED });

export const getAuthenticationState =
  () =>
  async (
    dispatch: Dispatch,
    getState: () => OneAppStore,
    { fetchClient }: { fetchClient: typeof fetch }
  ) => {
    const state = getState();
    const isAuthenticated = state.getIn([
      'modules',
      'one-ap-root',
      'authenticated',
      'isAuthenticated',
    ]);
    if (!isAuthenticated) {
      const oneDataApiUrl = state.getIn(['config', 'oneDataApiUrl']);
      const fetchOptions = {
        credentials: 'include',
      } as const;
      const response = await fetchClient(
        `${oneDataApiUrl}/ReadUserSession.v1`,
        fetchOptions
      );
      if (!response.ok) {
        return false;
      }
      dispatch(setAuthenticated());
    }
    return true;
  };

const initialState = Immutable.fromJS({
  isAuthenticated: false,
});

// eslint-disable-next-line default-param-last -- redux convention
const reducer: Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTHENTICATED:
      return state.set('isAuthenticated', true);
    default:
      return state;
  }
};

export default reducer;
